import React from "react";
import { Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import { SITE, whatsappLink } from "@/config/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy-800 text-white pt-20 pb-10">
      <div className="container-tight">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full bg-white/5 ring-1 ring-white/10 flex items-center justify-center overflow-hidden">
                <img src={SITE.brand.logo} alt="iLg" className="h-9 w-9 object-contain" />
              </div>
              <div>
                <div className="font-display text-xl">Instituto Leopoldo Guimarães</div>
                <div className="text-[11px] uppercase tracking-[0.22em] text-bordeaux-200 font-semibold mt-0.5">Instituto de Formação · Academia de Estudos</div>
              </div>
            </div>
            <p className="mt-5 text-white/70 leading-relaxed max-w-md text-sm">
              Excelência académica, preparação Cambridge e desenvolvimento pessoal —
              num ambiente premium, próximo e acolhedor.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={SITE.contact.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white hover:text-navy-800 transition-colors"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 font-semibold mb-5">Navegação</div>
            <ul className="space-y-3 text-sm">
              {[
                ["#servicos", "Serviços"],
                ["#cambridge", "Cambridge"],
                ["#formacoes", "Formações DGERT"],
                ["#wellbeing", "Wellbeing"],
                ["#filosofia", "Filosofia"],
                ["#faq", "FAQ"],
                ["#contacto", "Contacto"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a href={h} className="text-white/75 hover:text-white transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 font-semibold mb-5">Contactos</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MessageCircle size={16} className="mt-0.5 text-bordeaux-200 shrink-0" />
                <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="text-white/85 hover:text-white">{SITE.contact.whatsappDisplay}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-bordeaux-200 shrink-0" />
                <a href={`mailto:${SITE.contact.email}`} className="text-white/85 hover:text-white break-all">{SITE.contact.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-bordeaux-200 shrink-0" />
                <span className="text-white/85">{SITE.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <div>© {new Date().getFullYear()} Instituto Leopoldo Guimarães. Todos os direitos reservados.</div>
          <div>Instituto de Formação · Academia de Estudos · Wellbeing</div>
        </div>
      </div>
    </footer>
  );
};
